import React, { useState, useEffect} from 'react';

import { useDispatch, useSelector } from 'react-redux'; //TE for DataPersistence for RjectMitigationPage
import { saveRejectMitigation, clearRejectMitigation } from 'stores/modules/cap/selfassessmentreducer'; //TE for DataPersistence for RjectMitigationPage

import { useLocation,useNavigate } from 'react-router-dom';

import {useNotification} from 'config/Notification';

import LoadingOverlay from 'components/LoadingOverlay.jsx';

import '../../styles/cap.css';

import { fetchAssessmentReportdetailsforReview  as fetchAssessmentReportdetailsforReviewService} from 'services/modules/cap/standardservice';
import { updateRejectedMitigationComments as updateRejectedMitigationCommentsService} from 'services/modules/cap/assessmentservice';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { 
  Collapse,
  IconButton,
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
 
} from '@mui/material';

const RejectMitigationPage = () => {
  // State variables
  const [assessmentsList,setAssessmentsList]=useState([]);
  const [expandedRow, setExpandedRow] = useState(null); 
  const [loading, setLoading] = useState(true);
  // const [mitigation, setMitigation] = useState({}); //TE for DataPersistence for RejectMitigationPage commented out this line

  // Location
  const location = useLocation();
  const urlparams = location.state;

  // React router
  const navigate = useNavigate();
  //TE for DataPersistence for RejectMitigationPage start
  const dispatch = useDispatch();
  const mitigation = useSelector(
    (state) => state.capSelfAssessment.rejectMitigation
  );
  //TE for DataPersistence for RejectMitigationPage end

  // Notification
  const { openNotification } = useNotification();
 
  // Method handles to change the value
  const handleInputChange = (event, submissionID) => {
    const { value } = event.target;
    //TE for DataPersistence for RejectMitigationPage commented the following block of code
    // setMitigation(prevState => ({
    //   ...prevState,
    //   [submissionID]: value
    // }));
    //TE for DataPersistence for RejectMitigationPage start
    dispatch(saveRejectMitigation({
        submissionID,
        value
    }));
    //TE for DataPersistence for RejectMitigationPage end

  };
  
  useEffect(()=>{  
    fetchPendingAssessments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
   
  // Method handles to fetch the assessment details
  const fetchPendingAssessments=async ()=> {
    setLoading(true);
    try {
      let params = {assessmentid:urlparams.assessmentid};
      const response = await fetchAssessmentReportdetailsforReviewService({  params });
      
      // code change for reject mitigation page error
      const data = Array.isArray(response.data)
        ? response.data
        : response.data?.controls || [];

      // code change for reject mitigation page error
      setAssessmentsList(data);
      
    } catch (error) {
      openNotification("Error fetching pending assessments:", 'error'); 
    }finally{
      setLoading(false);
    }     
  };
 
  // Method handles to reject & update the status of assessment
  const rejectAssessmentSubmit =async() => {
    try{
      let itemList=[];
      let assessment_id = urlparams.assessmentid;

      for (let i = 0; i < assessmentsList.length; i++) {  
        for (let j = 0; j < assessmentsList[i].subcontrols.length; j++) {  
          let comments = mitigation[assessmentsList[i].subcontrols[j].submissionID];
          if(comments && comments.trim()!=='' ){
            // code change for reject mitigation API error
            let obj= {
              "assessment_id": assessment_id,
              "control_id": assessmentsList[i].controlID,
              "submissionId": assessmentsList[i].subcontrols[j].submissionID,
              "rejected_comments": comments
            };
            itemList.push(obj);
          }
        }
      }

      // code change for reject mitigation API error
      if (itemList.length === 0) {
        console.error("Reject remarks missing");
        openNotification('Please enter atleast one reject remarks', 'error');
        return;
      }

      // code change for reject mitigation API error
      const body = itemList;

      let response = await updateRejectedMitigationCommentsService(body);   
      if(response?.status === 201 || response?.status === 200){
        dispatch(clearRejectMitigation()); //TE for DataPersistence for RejectMitigationPage
        openNotification('Rejected successfully.', 'success');
        navigate('/cap/mitigationplan');
      }
    } catch (error) {
      openNotification('Server Error','error');
    }
  };
    
  return (
    <div>
      <div className="row py-1">
        <p>
          <img className="px-1 icons-style" src="../assets/icons/003-clipboard.svg" alt="View"  />
          <b className="px-1">Reject mitigation </b>
          <img className="px-1 icons-style" src="../assets/icons/right-layer.svg" alt="View"   />

          {urlparams.standard==='CIS' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-cis.png"   draggable="false" alt='CIS-Icon'/>
          )}
          {urlparams.standard==='ISO-27001' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-iso-27001.png"   draggable="false" alt='CIS-Icon'/>
          )}
          {urlparams.standard==='NIST' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-nist.png"   draggable="false" alt='NIST-Icon'/>
          )}
          {urlparams.standard==='COBIT' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-cobit.png"   draggable="false" alt='COBIT-Icon'/>
          )}
          {urlparams.standard==='TISAX' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-tisax.png"   draggable="false" alt='TISAX-Icon'/>
          )}
          {urlparams.standard==='NIS 2.0' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-nis2.png"   draggable="false" alt='NIS-Icon'/>
          )}
          {urlparams.standard==='Ransomware' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-ransomware.png"   draggable="false" alt='Ransomware-Icon'/>
          )}
          {urlparams.standard==='Data Protection' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-data-protection.png"   draggable="false" alt='DP-Icon'/>
          )}
          {urlparams.standard==='Supplier Risk' && (
            <img className="px-sm standard-icon-size"  src="../assets/icons/standard-supplier-risk.png"   draggable="false" alt='SR-Icon'/>
          )}  
          <span> { urlparams.standard }  </span> - <span>{ urlparams.assessmentid }</span> 
        </p>
      </div>
      {loading && <LoadingOverlay />}
      <div>
        {assessmentsList.length>0 &&(
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>    
                  <TableCell colSpan={3}>Control name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {assessmentsList.length>0 &&
                  assessmentsList.map((item) => (
                    <React.Fragment key={item.controlID}>
                      <TableRow >
                        <TableCell>
                          <IconButton
                            className='expand-row'
                            size="small"
                            onClick={() => setExpandedRow((prevRow) => (prevRow === item.controlID ? null : item.controlID))}
                          >
                            {expandedRow === item.controlID ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell>
                        <TableCell>{item.controlID +' : ' + item.controlName}</TableCell>
                        <TableCell>{item.assessment_id}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={3}>
                          <Collapse in={expandedRow === item.controlID} timeout="auto" unmountOnExit>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Ref</TableCell>
                                  <TableCell>Control</TableCell>
                                  <TableCell>Rating</TableCell>
                                  <TableCell>Rationale for rating</TableCell>
                                  <TableCell>Mitigation suggested</TableCell>
                                  <TableCell>Action taken</TableCell>
                                  <TableCell>Evidence</TableCell>
                                  <TableCell>Reject remarks</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {item.subcontrols.map((subcontrol) => (
                                  <TableRow key={subcontrol.subcontrolID}>
                                    <TableCell>{subcontrol.subcontrol}</TableCell>
                                    <TableCell>
                                      <div className='subcontrols'>
                                        {subcontrol.subcontrolName}
                                      </div>
                                    </TableCell>
                                    <TableCell  className='subcontrols'>{subcontrol.severity}</TableCell>
                                    <TableCell  className='subcontrols'>{subcontrol.rational}</TableCell>
                                    <TableCell  className='subcontrols'>{subcontrol.mitigation}</TableCell>
                                    <TableCell  className='subcontrols'>{(subcontrol.mitigationresponse!==undefined && subcontrol.mitigationresponse.remarks!==undefined)&&   subcontrol.mitigationresponse.remarks}</TableCell>
                                    <TableCell  className='subcontrols'>{(subcontrol.mitigationresponse!==undefined && subcontrol.mitigationresponse.evidence!==undefined)&&   <a className='text-primary' href={subcontrol.mitigationresponse.evidence} target="_blank" rel="noreferrer"> Download </a>}</TableCell>
                                    <TableCell>
                                      <textarea
                                        key={subcontrol.submissionID}
                                        id={subcontrol.submissionID}
                                        className="mit1"
                                        style={{ minWidth: '300px' }}
                                        value={mitigation[subcontrol.submissionID] || ''}
                                        onChange={(e) => handleInputChange(e, subcontrol.submissionID)}
                                        placeholder="Reject remarks"
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {assessmentsList.length>0 &&(
          <div className='assessments-list' >
            <button
              className="go-back-button w-150"
              onClick={()=> navigate('/cap/mitigationplan')}
            >
              <ArrowLeftIcon  />
              Go back
            </button>
            <button
              className="reject-button w-150"
              onClick={()=>rejectAssessmentSubmit()}
            >
              Reject
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default RejectMitigationPage;
